import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatusSelectionComponent } from './status-selection.component';
import { Select2Module } from 'src/app/shared/ui/forms/inputs/oops-select2/select2.module';

@NgModule({
    declarations: [
        StatusSelectionComponent
    ],
    imports: [
        CommonModule,
        Select2Module
    ],
    exports: [
        StatusSelectionComponent
    ]
})
export class StatusSelectionModule { }
